import styles from './styles.module.css'
import { useTranslation } from 'next-i18next'
import Form from './Form'
import '@/app/validation/yupFileValidator'
import { UserIcon } from '@/components/ui/icons'

const WriteMessage = ({ user, onClose, onSubmit, isAuthor = false }) => {
  const { t } = useTranslation(['common', 'objectWrite'])

  return (
    <div className={styles.writeMessageStyle}>
      <div className={styles.writeMessageTitle}>
        <div className={styles.writeMessageTitleText}>
          {isAuthor ? t('objectWrite::author') : t('objectWrite::text')}
        </div>
        <div className={styles.writeMessageUser}>
          <div className={styles.writeMessageUserLeft}>
            <div className={styles.writeMessageUserLogo}>
              {user?.avatarUrl ? (
                <img
                  className={styles.writeMessageUserLogoImage}
                  src={user?.avatarUrl}
                  alt="user logo"
                  width={31}
                  height={31}
                />
              ) : (
                <div className={styles.writeMessageUserLogoWrapper}>
                  <UserIcon />
                </div>
              )}
            </div>
            <div className={styles.writeMessageWrapperUserName}>
              <div className={styles.writeMessageUserName}>{user?.name}</div>
              <div className={styles.writeMessageUserStatus}>{user?.isPrivate}</div>
            </div>
          </div>
        </div>
      </div>
      <Form onClose={onClose} onSubmit={onSubmit} />
    </div>
  )
}

export default WriteMessage
